import { z } from "zod";

// ============================================================================
// PUBLISHABLE RESOURCE (camelCase for frontend)
// ============================================================================

export const PublishableResourceSchema = z.object({
  resourceType: z.enum(["agent", "knowledge_base"]),
  resourceId: z.string().uuid(),
  groupId: z.string().uuid(),
  releaseVersion: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  status: z.string(),
  publicationStatus: z.string(),
  rejectionReason: z.string().nullable(),
  releasedAt: z.string().nullable(),
  createdAt: z.string(),
  workspaceId: z.string().uuid(),
  specialty: z.string().nullable(),
  usageContext: z.string().nullable(),
  operations: z.array(z.string()),
  patientTypes: z.array(z.string()),
  tags: z.array(z.string()),
  createdWithAi: z.boolean(),
});

export type PublishableResource = z.infer<typeof PublishableResourceSchema>;

// ============================================================================
// API RESPONSE
// ============================================================================

export const GetMyPublishableResourcesResponseSchema = z.object({
  resources: z.array(PublishableResourceSchema),
});

export type GetMyPublishableResourcesResponse = z.infer<typeof GetMyPublishableResourcesResponseSchema>;
